import styled from 'styled-components';

export const StyledStaffWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;

  table td:last-child {
    text-align: right;
  }
`;
